/////////////// Not Fixed Yet

import React from "react";
import { 
    Page, 
    Text,
    Document, 
    Image,
    Font,
    StyleSheet,
    Line,
    Svg,
    Polygon,
} from '@react-pdf/renderer';

const Doc = ({data}) => {
    
    Font.register({
        family: 'THSarabunNew',
        fonts: [
            {src: `${process.env.REACT_APP_URL}fonts/THSarabunNew.ttf`},
            {src: `${process.env.REACT_APP_URL}fonts/THSarabunNew Bold.ttf`, fontWeight: 'bold'}
        ]
    });

    const styles = StyleSheet.create({
        // image: {margin: 20,marginLeft: 50 ,width: 155, height: 200},
        text: {fontSize: 15 , fontFamily: 'THSarabunNew'},
        textLeft:{position: 'absolute', left: 50},
        textCenter:{position: 'absolute', left: 220},
        textRight: {position: 'absolute', left: 400},
        textgrade: {top:450, position: 'absolute', fontSize: 26 , fontFamily: 'THSarabunNew', fontWeight:'bold'},
        textYear: {top:430, position: 'absolute',},
        textInHeader: {color: 'white'},
        textMainTop : {fontSize: 20 , fontFamily: 'THSarabunNew', fontWeight: 'bold'}
    });

    return(
        <Document >
           <Page size='A4' style={{flexDirection : 'row',}}>
                <Svg height="300" width="600" style={{position: 'absolute'}}>
                    <Polygon
                        points='0,0 600,0 600,230 0,230 '
                        fill='#00054c'
                        stroke='#00054c'
                        strokeWidth={0}
                    />
                </Svg>
                <Image 
                      style={{margin: 20,marginLeft: 30 ,width: 165, height: 190}}
                      src={`${process.env.REACT_APP_API_URL}image/profile/${data.avatarImg}`}
                 />
                <Text style={[styles.text,styles.textCenter, styles.textInHeader,{top:30}]} >
                    <Text> ID : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.id}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight, styles.textInHeader,{top: 30} ]} >
                    <Text>Status :</Text> 
                    <Text style={{ fontWeight: 'bold'}}> {data.status === 'member' ? 'meber': 'fire'} </Text>
                </Text>
                <Text style={[styles.text,styles.textCenter, styles.textInHeader,{top:70}]} >
                    <Text> Name : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.firstName} {data.lastName}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight, styles.textInHeader, {top: 70} ]} >
                    <Text>Position : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.duty}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter, styles.textInHeader, {top:110}]} >
                    <Text>Birthday :</Text>
                    <Text style={{ fontWeight: 'bold'}}> {data.birthday}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight, styles.textInHeader, {top: 110} ]} >
                    <Text>Age : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.age}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter, styles.textInHeader, {top:150}]} >
                    <Text>Hiring Date : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.hireDate}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight, styles.textInHeader, {top: 150} ]} >
                    <Text>Service Year : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.serviceYear}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter, styles.textInHeader, {top:190}]} >
                    <Text>ESY : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.esy}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight, styles.textInHeader, {top: 190} ]} >
                    <Text>OESY : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.oesy}</Text>
                </Text>

                <Text style={[styles.text,styles.textLeft, {top:240}]}>
                    <Text>Company : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.company}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter,{top:240}]}>
                    <Text>Job Group : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.jobGroup.name}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight,{top:240}]}>
                    <Text>Sub Job Group : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.jobGroup.subJob}</Text>
                </Text>
                <Text style={[styles.text,styles.textLeft, {top:260}]}>
                    <Text>Division : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.division}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter,{top:260}]}>
                    <Text>Department : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.department}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight,{top:260}]}>
                    <Text>Section : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.section}</Text>
                </Text>
                
                 <Svg height="300" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='290' 
                        x2='550' 
                        y2='290' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>
                
                <Text style={[styles.text,styles.textLeft, {top:300}]}>
                    <Text>Employment type : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.roleUser}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter,{top:300}]}>
                    <Text>Job Level : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.level}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight,{top:300}]}>
                    <Text>Personnel Level : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.PersonLevel}</Text>
                </Text>
                <Text style={[styles.text,styles.textLeft, {top:320}]}>
                    <Text>TIG : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.tig}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter,{top:320}]}>
                    <Text>TIP : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.tip}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight,{top:320}]}>
                    <Text>Work Location : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.section}</Text>
                </Text>
                
                <Svg height="360" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='350' 
                        x2='550' 
                        y2='350' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>
               
                <Text style={[styles.text,styles.textLeft, {top:360}]}>
                    <Text>Working Type : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.workType}</Text>
                </Text>
                <Text style={[styles.text,styles.textCenter,{top:360}]}>
                    <Text>Payment Type : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.payType}</Text>
                </Text>
                <Text style={[styles.text,styles.textRight,{top:360}]}>
                    <Text>Salary : </Text>
                    <Text style={{ fontWeight: 'bold'}}>{data.salary}</Text>
                </Text>
                
                <Svg height="400" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='390' 
                        x2='550' 
                        y2='390' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>

                <Text style={[styles.textMainTop, styles.textLeft, {top: 400 }]}>
                    Performance protentail
                </Text>
                <Text style={[styles.text, styles.textYear,{left: 75}]}>
                    {data.potential[data.potential.length-1].year}
                </Text>
                <Text style={[styles.textgrade, {left: 80, }]}>
                    {data.potential[data.potential.length-1].grade}
                </Text>
                <Text style={[styles.text, styles.textYear,{left: 175}]}>
                    {data.potential[data.potential.length-2].year}
                </Text>
                <Text style={[styles.textgrade, {left: 180, }]}>
                    {data.potential[data.potential.length-2].grade}
                </Text>
                <Text style={[styles.text, styles.textYear,{left: 275}]}>
                    {data.potential[data.potential.length-3].year}
                </Text>
                <Text style={[styles.textgrade, {left: 280, }]}>
                    {data.potential[data.potential.length-3].grade}
                </Text>
                <Text style={[styles.text, styles.textYear,{left: 375}]}>
                    {data.potential[data.potential.length-4].year}
                </Text>
                <Text style={[styles.textgrade, {left: 380, }]}>
                    {data.potential[data.potential.length-4].grade}
                </Text>
                <Text style={[styles.text, styles.textYear,{left: 475}]}>
                    {data.potential[data.potential.length-5].year}
                </Text>
                <Text style={[styles.textgrade, {left: 480, }]}>
                    {data.potential[data.potential.length-5].grade}
                </Text>
                
                <Svg height="500" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='490' 
                        x2='550' 
                        y2='490' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>
                
                <Text style={[styles.textMainTop, styles.textLeft, {top: 500 }]}>
                    Education
                </Text>
                {data && data.education.map((val,index) => 
                    <Text key={index} style={[styles.text, styles.textLeft, {top: 520 + (index*20) }]} >
                        <Text style={{fontWeight:'bold',}}>
                            {val.degree}
                        </Text>
                        <Text>
                             , {val.year}
                        </Text>
                        <Text style={{fontWeight:'bold',}}>
                             , {val.major} 
                        </Text>
                        <Text>
                            , {val.faculity} faculity  , {val.institute}, {val.country}
                        </Text>
                    </Text>
                )}
                <Svg height="600" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='590' 
                        x2='550' 
                        y2='590' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>
                
                <Text style={[styles.textMainTop, styles.textLeft, {top: 600 }]}>
                    External Experience
                </Text>
                {data && data.experience.map((val,index) =>
                    <Text key={index} style={[styles.text, styles.textLeft, {top: 620 + (index*20) }]}>
                        <Text style={{fontWeight:'bold',}}>
                            {val.position}
                        </Text>
                        <Text >
                            &nbsp; at {val.department} , {val.company} , {val.province} , {val.country} &nbsp; since &nbsp; {val.date}
                        </Text>
                    </Text>
                )}
                
                <Svg height="700" width="600" style={{position: 'absolute'}}>
                    <Line 
                        x1='40' 
                        y1='690' 
                        x2='550' 
                        y2='690' 
                        strokeWidth={1} 
                        stroke="#d4d4d4"
                    />
                </Svg>
                
                <Text style={[styles.textMainTop, styles.textLeft, {top: 700 }]}>
                    Internal Experience
                </Text>
                {data && data.internalExperience.map((val,index) =>
                    <Text key={index} style={[styles.text, styles.textLeft, {top: 720 + (index*20) }]}>
                        <Text style={{fontWeight:'bold',}}>
                            {val.position}
                        </Text>
                        <Text >
                            &nbsp; at {val.department} , {val.company} , {val.province} , {val.country} &nbsp; since &nbsp; {val.date}
                        </Text>
                    </Text>
                )}
           </Page>
        </Document>
    )
}

export default Doc;